module.exports = __webpack_public_path__ + "static/media/tick.9ce79653.svg";